<div class="relative">
	<div class="card">
		<div class="{{ isFlipped ? 'content' : 'content content1' }}">
			<div *ngIf="queryParamsData.status == 1" class="front">
				<app-accept-reject-payout
					(isFlipped)="
						isFlipped = $event; flipped.emit($event); actionChanged.emit(true)
					"
					[clientData]="clientDeatailsData"
				></app-accept-reject-payout>
			</div>

			<div *ngIf="queryParamsData.status != 1" class="front">
				<app-client-profile-payout-details
					(isFlipped)="isFlipped = $event; flipped.emit($event)"
					[clientDeatailsData]="clientDeatailsData"
				></app-client-profile-payout-details>
			</div>
			<div class="back h-[900px]">
				<section class="bg-off-white">
					<!-- DATA SECTION  -->
					<div
						*ngFor="
							let payout of payoutDataTable
								| paginate
									: {
											itemsPerPage: payoutDataFilter?.paging?.pageSize,
											currentPage: payoutDataFilter?.paging?.pageNumber,
											totalItems: totalCount
									  };
							let indx = index
						"
						class="pb-[10px] pt-2 bg-[#F5F5F5] ] cursor-pointer {{
							indx + 1 != payoutDataTable.length
								? 'border-b-[1px] border-secondry-color-Gray h-[63px]'
								: ''
						}}"
					>
						<!--  -->
						<a
							(click)="
								isFlipped = !isFlipped;
								toggle();
								flipChange(payout.id, payout.payoutStatus);
								getDetails(payout.id)
							"
						>
							<div class="ltr:pl-16px ltr:pr-24px rtl:px-24px flex">
								<img
									class="ltr:mr-16px rtl:ml-16px w-[24px] h-[24px] mt-[2%]"
									[src]="
										payout?.payoutMethod?.id == 1
											? 'assets/images/bank.png'
											: payout?.payoutMethod?.id == 2
											? 'assets/images/Fawri.svg'
											: 'assets/images/instapay.svg'
									"
								/>
								<div class="flex-grow-[2]">
									<h1 class="text-dark-grey text-font-16 mb-0">
										{{ payout?.id }}
									</h1>
									<p
										*ngIf="payout?.payoutStatus != 1"
										class="text-medium-gray text-font-12 mb-0"
									>
										{{
											payout?.actionDate | date : 'dd/MM/yyyy , hh:mm a' : 'UTC'
										}}
									</p>
									<p
										*ngIf="payout?.payoutStatus == 1"
										class="text-medium-gray text-font-12 mb-0"
									>
										{{
											payout?.transactionDate
												| date : 'dd/MM/yyyy , hh:mm a' : 'UTC'
										}}
									</p>
								</div>
								<div>
									<app-status
										[enumData]="PaymentPayoutStatus"
										[statusValue]="payout?.payoutStatus"
									>
									</app-status>
									<h1
										class="text-font-14 font-DIN-bold font-bold text-[#4E4B66]"
									>
										{{
											this.translate.currentLang == 'en'
												? payout?.currency?.name?.en
												: payout?.currency?.name?.ar
										}}
										{{ payout?.requiredAmount }}

										<span class="mx-2">></span>
									</h1>
								</div>
							</div>
						</a>
						<!-- SEPARATOR -->
					</div>
				</section>
			</div>
		</div>
	</div>
</div>
